import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manage-menucloud';

const list = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/menuGroupTimes`, payload);
};

const create = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/menuGroupTimes`, payload);
};

const find = (merchantId, id) => {
	return Client.get(`${baseUrl}/${merchantId}/menuGroupTimes/${id}`);
};

const update = (merchantId, id, payload) => {
	return Client.put(`${baseUrl}/${merchantId}/menuGroupTimes/${id}`, payload);
};

const remove = (merchantId, id, payload) => {
	return Client.del(`${baseUrl}/${merchantId}/menuGroupTimes/${id}`, payload);
};

export default {
	list,
	find,
	create,
	update,
	remove,
};
